module.exports = __webpack_public_path__ + "img/office3.b9215485.png";